import { VueEditor } from 'vue2-editor'
// import { Api } from '@/service';
import  codes from '@/codes';
import vSelect from 'vue-select';

//restful api
import { qna as board } from '@/service/api/board';

export default {
  components: { VueEditor, vSelect },
  data : () => ({ codes, confirm: false, add: false, lock: true, model : {} }),
  methods: {
    cancel() { this.lock = true; },
    edit() { this.lock = false; },
    async remove() {
      try {
        // let rs = await Api.Manager_Call('board.qna', 'remove', { id : this.model.id });
        let rs = await board.delete({ id : this.model.id });
        if(!rs.error) {
          this.$toastr.s('removed.', this.$route.name)
        } else {
          this.$toastr.e('remove', "failed")
        }
        this.list();
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); this.list(); }
    },
    async save() {
      if(!(this.model.answer || '').trim()) { return this.$toastr.e('Answer is Require.'); }

      try {
        // let rs = await Api.Manager_Call('board.qna', this.model.id ? 'update' : 'insert', this.model);
        
        let rs = await board.update(this.model);
        if(!rs.error) {
          this.$toastr.s('Saved', this.$route.name);
          this.$emit('refresh');
        } else {
          this.$toastr.s('Save', 'failed');
        }
        this.cancel();
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); }
    },
    list() { this.$router.push({ name: 'board_qna'}); this.$emit('refresh')},
    async get(id = this.$route.params.id) {
      console.log('qan.detail.vue', 'load item', id);
      if(id !== 'add') {
        try {
          // let rs = await Api.Manager_Call('board.qna', 'detail', { id : id });
          let rs = await board.detail({ id : id });
          this.model = Object.assign({}, this.model, rs.body );
          return;
        } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); this.list(); }
      } else { this.lock = false; this.add = true; }
    }
  },
  watch: { '$route' (to, from) { this.get(to.params.id); console.log(`from : ${from}`); } },
  created() { console.log('qan.detail.vue', 'created'); },
  destroyed() { console.log('qan.detail.vue', 'destroyed'); },
  mounted() { console.log('qan.detail.vue', 'mounted'); this.get(this.$route.params.id); },
}